export default __webpack_public_path__ + "static/media/pills-1.27363e98.png";